module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-salary-type-select/ztsi-salary-type-select.component.css
// module id = ./src/app/components/shared/ztsi-salary-type-select/ztsi-salary-type-select.component.css
// module chunks = main